import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable()
export class HeaderService {

  @Output() showLoginRegisterButtons = new EventEmitter<boolean>();
  @Output() showRedUnderline = new EventEmitter<boolean>();
  @Output() isHomePage = new EventEmitter<boolean>();
  @Output() setFirstPositionOnTopMenu = new EventEmitter<boolean>();

  constructor() { }

  isHomepage(isHomePage: boolean) {
    this.showRedUnderline.emit(!isHomePage);
    this.isHomePage.emit(isHomePage);
  }

  hideLoginRegisterButtons() {
    this.showLoginRegisterButtons.emit(false);
  }
  setLoginRegisterButtonsVisible() {
    this.showLoginRegisterButtons.emit(true);
  }
  hideRedUnderline() {
    this.showRedUnderline.emit(false);
  }
}
